export const cards = [
    {
      image:
        "https://img.freepik.com/free-photo/analog-landscape-city-with-buildings_23-2149661462.jpg?t=st=1728569941~exp=1728573541~hmac=d115d8d250d4e7cfed4970be5f1c3045454426a7cf9b322876302e26ab49e14b&w=1060",
      title: "Welcome to Our School",
      text: "Your journey begins here.",
    },
    {
      image:
        "https://img.freepik.com/free-photo/bustling-school-cafeteria-lunchtime_1268-30762.jpg?t=st=1728569297~exp=1728572897~hmac=90a4fe5fe6f2b6590ff3ec2f447f3e2cc82ee0b2672cf3695a3b9b593191b1af&w=1380",
      title: "Welcome to Our School",
      text: "Your journey begins here.",
    },
    {
      image:
        "https://img.freepik.com/free-photo/students-learning-school-their-classroom_23-2149511018.jpg?t=st=1728569336~exp=1728572936~hmac=f87c39731de3399c571c6e11cfbc591cbde859d2378936e2080894365fa5f6d1&w=1060",
      title: "Innovative Learning",
      text: "Experience our cutting-edge programs.",
    },
    // Add more card objects as needed
  ];

 // src/galleryImages.js
export const imageUrls = [
  {
    src: "https://images.pexels.com/photos/11366728/pexels-photo-11366728.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    caption: "A serene moment in the classroom & Students engaged in learning & Students engaged in learning || A serene moment in the classroom & Students engaged in learning & Students engaged in learning"
  },
  {
    src: "https://images.pexels.com/photos/1234567/pexels-photo-1234567.jpeg",
    caption: "Students engaged in learning"
  },
  {
    src: "https://images.pexels.com/photos/11366728/pexels-photo-11366728.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    caption: "Quiet classroom ambiance"
  },
  {
    src: "https://img.freepik.com/free-photo/medium-shot-boy-holding-book_23-2148892765.jpg?t=st=1728568866~exp=1728572466~hmac=d55a9b98e8071642da19161729ad21831ff788957baf392afb3cabc18355e37a&w=740",
    caption: "A student with a passion for books"
  },
  {
    src: "https://images.pexels.com/photos/1234567/pexels-photo-1234567.jpeg",
    caption: "Group activities in the classroom"
  },
  {
    src: "https://img.freepik.com/free-photo/empty-classroom-due-coronavirus-pandemic_637285-8845.jpg?t=st=1728568792~exp=1728572392~hmac=7db40890456a0763732b87bcb1df8479aa9ae1319b0af0db9b65667609cc7d83&w=1060",
    caption: "An empty classroom prepared for students"
  },
  {
    src: "https://images.pexels.com/photos/11366728/pexels-photo-11366728.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    caption: "Preparing for a day of learning"
  },
  {
    src: "https://images.pexels.com/photos/1234567/pexels-photo-1234567.jpeg",
    caption: "A focused student in class"
  },
  {
    src: "https://images.pexels.com/photos/11366728/pexels-photo-11366728.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    caption: "Bright and engaging learning space"
  },
  {
    src: "https://img.freepik.com/free-photo/students-knowing-right-answer_329181-14271.jpg?t=st=1728568738~exp=1728572338~hmac=1123b00d0fa4648de829e059a73bd392430cf569b51670163c96bfc67f75e9f5&w=1060",
    caption: "Celebrating student success"
  }
];


export const teachersData = [
  {
    id: 1,
    name: "Gaurav Mishra",
    subject: "English",
    imageUrl:
      "https://img.freepik.com/free-photo/portrait-female-teacher-school-classroom_23-2150911641.jpg?t=st=1728749498~exp=1728753098~hmac=a2afb5c5793f380d1fde2b4196c813aed596fe12854065dc2cedffeb61afc5e4&w=1060",
    bio: "Gaurav has a passion for literature and aims to inspire his students to explore the world of books. With over 5 years of teaching experience, he specializes in creative writing and poetry."
  },
  {
    id: 2,
    name: "Anjali Verma",
    subject: "Mathematics",
    imageUrl:
      "https://img.freepik.com/free-photo/portrait-female-teacher-school-classroom_23-2149270711.jpg?w=1060",
    bio: "Anjali believes that mathematics is the key to understanding the world. With a strong background in algebra and geometry, she has been teaching for over 7 years, helping students build confidence in their math skills."
  },
  {
    id: 3,
    name: "Rahul Sharma",
    subject: "Science",
    imageUrl:
      "https://img.freepik.com/free-photo/portrait-female-teacher-school-classroom_23-2150911641.jpg?w=1060",
    bio: "Rahul is dedicated to making science accessible and exciting for all students. With a focus on hands-on learning, he has 8 years of teaching experience in biology and chemistry."
  },
  {
    id: 4,
    name: "Priya Gupta",
    subject: "History",
    imageUrl:
      "https://img.freepik.com/free-photo/portrait-female-teacher-school-classroom_23-2150911641.jpg?w=1060",
    bio: "Priya has a deep love for history and enjoys bringing the past to life for her students. With a Master's in History, she has been teaching for 6 years and emphasizes critical thinking and analysis."
  },
  {
    id: 5,
    name: "Vikram Mehta",
    subject: "Physical Education",
    imageUrl:
      "https://img.freepik.com/free-photo/portrait-female-teacher-school-classroom_23-2150911641.jpg?w=1060",
    bio: "Vikram is committed to promoting physical fitness and healthy living among his students. With over 10 years of experience, he encourages teamwork and perseverance through sports."
  },
  // Add more dummy data as needed
];


export const toppersData = [
  {
    name: "Lara Croft",
    className: "XI",
    year: "2022-2024",
    percentage: 93,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "An adventurous learner with a passion for archaeology and history.",
  },
  {
    name: "John Doe",
    className: "XI",
    year: "2022-2024",
    percentage: 95,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "A dedicated student who excels in mathematics and science.",
  },
  {
    name: "Emma Watson",
    className: "XI",
    year: "2022-2024",
    percentage: 92,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "An advocate for education and a leader in the student council.",
  },
  {
    name: "Peter Parker",
    className: "XI",
    year: "2022-2024",
    percentage: 94,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "A creative thinker with a keen interest in photography.",
  },
  {
    name: "Bruce Wayne",
    className: "XI",
    year: "2022-2024",
    percentage: 96,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "A philanthropist who is passionate about helping others.",
  },
  {
    name: "Clark Kent",
    className: "XI",
    year: "2022-2024",
    percentage: 91,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "A journalist with a curiosity for the truth and a love for writing.",
  },
  {
    name: "Diana Prince",
    className: "XI",
    year: "2022-2024",
    percentage: 97,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "A champion for justice and a leader in community service.",
  },
  {
    name: "Tony Stark",
    className: "XI",
    year: "2022-2024",
    percentage: 98,
    imageUrl:
      "https://as2.ftcdn.net/v2/jpg/10/16/40/19/1000_F_1016401913_Dz4YOrT6I2qsYVi7xzRL2oAaSNEeretl.jpg",
    bio: "An innovator with a talent for technology and engineering.",
  },
];


  export const activityData = [
    {
      title: 'English Summer Camp',
      description: 'Play As You Learn English Summer Camp Nam ullamcorper, diam sit amet euismod pellentesque.'
    },
    {
      title: 'Math Wizards',
      description: 'Join us for a fun and interactive Math camp where numbers come to life through games.'
    },
    {
      title: 'Artistic Adventures',
      description: 'Explore your creativity in our Art camp filled with painting, drawing, and sculpting.'
    },
    {
      title: 'Science Explorers',
      description: 'Discover the wonders of science with experiments, field trips and exciting projects.'
    },
    {
      title: 'Coding Camp',
      description: 'Learn the basics of programming and create your own video games and applications.'
    },
    {
      title: 'Outdoor Survival Skills',
      description: 'Gain skills in the great outdoors with our camp focused on survival tactics and teamwork.'
    }
  ];